import { shallowRef } from 'vue'
import QuizEditDialog from '@/components/quiz/QuizEditDialog.vue'
import QuizDetailsPanel from '@/components/panels/QuizDetailsPanel.vue'
import QuizDashboardPanel from '@/components/panels/QuizDashboardPanel.vue'
import QuizAttemptsPanel from '@/components/panels/QuizAttemptsPanel.vue'

export default {
    ICON: 'mdi-help-circle-outline',
    TYPE: 'Quiz',
    SINGULAR: 'Quiz',
    PLURAL: 'Quizzes',
    ROUTE: 'quiz/',
    DELETE: 'quiz/',
    CREATE: 'quiz/',
    UPDATE: 'quiz/',
    FORM: shallowRef(QuizEditDialog),
    DETAILPANEL: QuizDetailsPanel,
    HASDETAIL: true,
    TABLEHEADERS: [
        { title: 'Name', key: 'name' },
        { title: 'Duration', key: 'totalTimeMinutes' },
        { title: 'Questions', key: 'questionCount' },
        { title: 'Created', key: 'dateCreated' },
        { title: '', key: 'controls' }
    ],
    PANELS: [
        { title: 'Overview', component: QuizDashboardPanel, size: 12, inCard: true, autoHeight: true },
        { title: 'Attempts', component: QuizAttemptsPanel, size: 12, inCard: false, autoHeight: true }
    ]
}
